import Icon from '../components/Icon.vue'

Icon.register({
  paragraph: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 48v32c0 8.8-7.2 16-16 16h-48v368c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-368h-32v368c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-112h-32c-88.3 0-160-71.7-160-160s71.7-160 160-160h240c8.8 0 16 7.2 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paragraph.js
// module id = 1609
// module chunks = 0